import React, {ComponentProps, Fragment, useEffect, useState} from "react";
import {RouteComponentProps, useParams} from "react-router";
import * as api from "../../apis/suit";
import * as categoryApi from "../../apis/productCategory";
import * as productApi from "../../apis/product";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {
    Button,
    Card,
    Col,
    Form,
    Input,
    InputNumber,
    Row,
    Space,
    Switch,
    Select as AntSelect,
    Table,
    message
} from "antd";
import Divider from "../../components/Divider";
import {Link, useHistory} from "react-router-dom";
import styles from "./index.module.css";
import {useForm, useWatch} from "antd/lib/form/Form";
import DatePicker from "../../components/DatePicker";
import CategoryCascader from "../../components/CategoryCascader";
import {useRequest} from "ahooks";
import Select from "../../components/Select";
import {getSuit} from "../../apis/suit";
import {ColumnProps} from "antd/lib/table";
import ProductSelectModal from "../../components/ProductSelectModal";
import withAuth from "../../utils/withAuth";
import {Decimal} from "decimal.js";

const EditButton = withAuth('edit', Button);
const StatusButton = withAuth('updateStatus', Button);

type RouteParam = {
    id?: string
}

function SuitDetail(props: RouteComponentProps<RouteParam>) {
    const history = useHistory();
    const param = useParams<RouteParam>();
    const [createMode, setCreateMode] = useState(!parseInt(param.id || ''));
    const [enableModify, setEnableModify] = useState(createMode);
    const [form] = useForm();
    const [categories, setCategories] = useState([]);
    const [productModalVisible, setProductModalVisible] = useState(false);
    const products = useWatch('products', form);
    const categoryId = useWatch('categoryId', form);
    const [productQueryParams, setProductQueryParams] = useState<any>({});

    useEffect(() => {
        if (!createMode) {
            getSuitById(parseInt(param.id!!))
        }
    }, [createMode]);
    useEffect(() => {
        setProductQueryParams({categoryId});
    }, [categoryId]);
    useEffect(() => {
        calcSuitAmount();
    }, [products]);

    const {loading, run: getSuitById} = useRequest(api.getSuit, {
        manual: true,
        defaultParams: [parseInt(param.id!!)],
        onSuccess(res) {
            form.setFieldsValue(res.data.data);
        }
    })

    const {loading: loadingCategory, run: getCategories} = useRequest(categoryApi.getCategoriesDict, {
        onSuccess(res) {
            const result = res?.data?.data?.map((c: any) => ({...c, children: []}));
            setCategories(result);
        }
    });
    const {loading: loadingSubmit, run: submit} = useRequest(api.modifySuit, {
        manual: true,
        onSuccess(res) {
            if (createMode) {
                setEnableModify(false);
                setCreateMode(false);
                history.replace(`/product/suit/detail/${res.data.data}`);
            } else {
                setEnableModify(false);
                setCreateMode(false);
                history.replace(`/product/suit/detail/${param.id}`);
            }
        }
    });
    const {loading: loadingUpdateStatus, run: updateStatus} = useRequest(api.updateStatus, {
        manual: true,
        onSuccess() {
            getSuitById(parseInt(param.id!!))
        }
    })

    const handleProductRemove = (record: any) => {
        const newProducts = products?.filter((p: any) => p.productId != record.productId);
        form.setFieldValue('products', []);
        form.setFieldValue('products', [...newProducts]);
    }

    const handleAddProducts = (keys?: Array<number>, records?: Array<any>) => {
        const filterRecords = (records || []).filter((p: any) => !(products || []).find((pp: any) => pp.productId == p.id));
        filterRecords.forEach((p:any)=>{
            p.productId = p.id;
            p.productCode = p.code;
            p.productName = p.name;
            p.productSpecification = p.specification;
            p.productUnit = p.unit;
            p.id = null;
        });
        form.setFieldValue('products', [...(products || []), ...filterRecords]);
        setProductModalVisible(false);
    }

    const columns: Array<ColumnProps<any>> = [
        {
            dataIndex: 'operation',
            title: '操作',
            render(v, record, i) {
                return <Space>
                    <Button onClick={() => handleProductRemove(record)}>-</Button>
                    <Button onClick={handleProductAdd}>+</Button>
                </Space>
            }
        },
        {
            dataIndex: 'productCode',
            title: '商品编号',
        },
        {
            dataIndex: 'productName',
            title: '商品名称'
        },
        {
            dataIndex: 'productSpecification',
            title: '商品规格'
        },
        {
            dataIndex: 'productUnit',
            title: '单位'
        },
        {
            dataIndex: 'qty',
            title: '数量',
            render(v, rec, i) {
                return rec.productId && <Form.Item name={[i, 'qty']} rules={[{required: true, message: '请输入数量'}]} initialValue={1}>
                    <InputNumber step={1} min={1}/>
                </Form.Item>
            }
        },
        {
            dataIndex: 'productQuote',
            title: '标准价'
        },
        {
            dataIndex: 'price',
            title: '销售价',
            render(v,rec, i){
                return rec.productId && <Form.Item name={[i, 'price']} rules={[{required: true}]}>
                    <InputNumber step={0.01} min={0}/>
                </Form.Item>
            }
        },
        {
            dataIndex: 'amount',
            title: '合计',
            render(v,rec,i){
                console.log(rec.qty, ' ', rec.price)
                return new Decimal(rec.qty||0).mul(new Decimal(rec.price||0)).toString();
            }
        }
    ];

    const calcSuitAmount = ()=>{
        if(!products?.length){
            form.setFieldValue('suitAmount',0)
        }else{
            const amount:Decimal= products.map((p:any)=>new Decimal(p.qty||0).mul(new Decimal(p.price||0))).reduce((i:Decimal, j:Decimal)=>i.add(j),new Decimal(0));
            form.setFieldValue('suitAmount', amount.toString())
        }
    }

    const toolbar = createMode ? null : (
        <Space className={styles.ToolBar}>
            <Divider>
                <EditButton type={'link'} loading={loadingSubmit} onClick={() => setEnableModify(true)}>修改</EditButton>
                <StatusButton type={'link'} loading={loadingUpdateStatus} onClick={() => updateStatus(parseInt(param.id!!), !form.getFieldValue('status'))}>{form.getFieldValue('status') ? '停用' : '启用'}</StatusButton>
                <Button type={'link'} onClick={() => history.goBack()}>返回</Button>
            </Divider>
        </Space>
    )


    const handleSubmit = () => {
        form.validateFields().then(value => {
            submit(value);
        });
    }

    const handleCancel = () => {
        setEnableModify(false);
        if (createMode) {
            history.goBack();
        }
    }
    const handleProductAdd = ()=>{
        const categoryId = form.getFieldValue('categoryId');
        if(!categoryId){
            message.error('请先选择产品线');
            return;
        }
        setProductQueryParams({categoryId});
        setProductModalVisible(true);
    }


    return <PageHeaderLayout withFooterBar={createMode || enableModify} onOk={handleSubmit} onCancel={handleCancel}>
        <Card title={toolbar}>
            <Form form={form} disabled={!enableModify}>
                <Form.Item name={'id'} noStyle/>
                <Row gutter={16} style={{padding: "0 40px"}}>
                    <Col span={12}>
                        <Form.Item name={'code'} label={'套餐编号'}>
                            <Input disabled placeholder={'自动生成'}/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name={'name'} label={'套餐名称'} rules={[{required: true}]}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name={'startDate'} label={'开始日期'} rules={[{required: true}]}>
                            <DatePicker picker={'date'}/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name={'endDate'} label={'结束日期'} initialValue={'2099-12-31'}
                                   rules={[{required: true}]}>
                            <DatePicker picker={'date'}/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name={'categoryId'} label={'产品线'} rules={[{required: true}]}>
                            <CategoryCascader options={categories} changeOnSelect
                                              disabled={!(createMode && enableModify) || !!form.getFieldValue('products')?.length}
                                              fieldNames={{label: "name", children: "children", value: "id"}}/>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item name={'status'} label={'状态'} initialValue={true} valuePropName={'checked'}>
                            <Switch checkedChildren={'启用'} unCheckedChildren={'停用'}
                                    disabled={!(createMode && enableModify)}/>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item name={'suitAmount'} label={'套餐销售价'}>
                            <InputNumber disabled/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item name={'remark'} label={'备注'}>
                            <Input.TextArea/>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.List name={'products'}>
                    {(fields, {add, remove}) => {
                        return <Table className={styles.Table} columns={columns} dataSource={form.getFieldValue('products')?.length?form.getFieldValue('products') : [{}]}
                                      rowKey={'productId'}/>
                    }}
                </Form.List>
            </Form>
            <ProductSelectModal multiple open={productModalVisible} onComplete={handleAddProducts}
                                onCancel={() => setProductModalVisible(false)} queryParams={productQueryParams}/>
        </Card>
    </PageHeaderLayout>
}

export default SuitDetail;